<template>
  <el-dialog
      :visible.sync="visible"
      title="新建客户"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="900px"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        @keyup.enter.native="dataFormSubmitHandle()"
        label-width="120px"
    >
      <el-form-item label="客户名称：" prop="name">
        <el-input v-model="dataForm.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="业务担当：" prop="businessMan">
        <el-select
            v-model="dataForm.businessMan"
            :multiple="true"
            :filterable="true"
            style="width:100%;"
        >
          <el-option
              :label="item.realName"
              :value="item.id"
              :key="item.id"
              v-for="item in userList"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="税号：" prop="receiptCode">
            <el-input
                v-model="dataForm.receiptCode"
                placeholder="税号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户行：" prop="bankName" label-width="80px">
            <el-input
                v-model="dataForm.bankName"
                placeholder="开户行"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="银行账号：" prop="bankCode">
            <el-input
                v-model="dataForm.bankCode"
                placeholder="银行账号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地址电话：" prop="address" label-width="80px">
            <el-input
                v-model="dataForm.address"
                placeholder="地址电话"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注：" prop="remark">
        <el-input
            v-model="dataForm.remark"
            placeholder="备注"
            type="textarea"
            :rows="4"
            resize="none"
        ></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  data () {
    return {
      visible: false,
      userList: {},
      dataForm: {
        id: '',
        name: '',
        remark: '',
        receiptCode: '',
        bankName: '',
        bankCode: '',
        address: '',
        businessMan: [],
      },
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ],
      }
    },
  },
  methods: {
    async getUserList () {
      const data = await this.$api2.get(`/sys/user/list`, { params: { roleId: this.$const.roleKeys.Business } })
      this.userList = data
    },
    init () {
      this.getUserList()
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http
          .get(`/trade/customer/${this.dataForm.id}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            let businessMan = []
            if (res.data && res.data.businessMan) {
              res.data.businessMan = res.data.businessMan.substr(1,
                  res.data.businessMan.length - 2
              )
              businessMan = res.data.businessMan.split(';')
            }
            console.log('businessMan', businessMan)
            this.dataForm = {
              ...this.dataForm,
              ...res.data,
              businessMan: businessMan
            }
          })
          .catch(() => {
          })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = this.$clone(this.dataForm)
            postForm.businessMan = `;${this.dataForm.businessMan.join(';')};`
            this.$http[!this.dataForm.id ? 'post' : 'put'](
                '/trade/customer/',
                postForm
            )
                .then(({ data: res }) => {
                  if (res.code !== 0) {
                    return this.$message.error(res.msg)
                  }
                  this.$message({
                    message: this.$t('prompt.success'),
                    type: 'success',
                    duration: 500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                    },
                  })
                })
                .catch(() => {
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },
}
</script>
